import type { CreatePaymentRequest, PaymentRail } from "@tilt/pos-sdk";

export interface PaymentFieldValues {
  checkNumber?: string | undefined;
  customerPhone?: string | undefined;
  deviceId?: string | undefined;
  iframeToken?: string | undefined;
  tenderedCents?: number | undefined;
}

export function buildPaymentRequest(
  rail: PaymentRail,
  amountCents: number,
  fields: PaymentFieldValues,
): CreatePaymentRequest {
  const req: Record<string, unknown> = {
    payment_type: rail.payment_type,
    amount_cents: amountCents,
  };
  if (rail.payment_subtype) {
    req.payment_subtype = rail.payment_subtype;
  }
  if (rail.requires_check_number && fields.checkNumber) {
    req.check_number = fields.checkNumber;
  }
  if (rail.requires_phone && fields.customerPhone) {
    req.customer_phone = fields.customerPhone;
  }
  if (rail.requires_device_picker && fields.deviceId) {
    req.device_id = fields.deviceId;
  }
  if (fields.iframeToken) {
    req.iframe_token = fields.iframeToken;
  }
  if (fields.tenderedCents !== undefined && fields.tenderedCents !== amountCents) {
    req.tendered_cents = fields.tenderedCents;
  }
  return req as unknown as CreatePaymentRequest;
}
